import { ReactElement } from 'react';
import { useTheme } from 'styled-components';

import { ReceptionService as WaitlistReceptionService } from '@dreryk/egabinet-waitlist-frontend-api';

import { Message, MessageOptions } from '@dreryk/react-components';

import { translationKeys } from '../../../translations';

const useOptions = (): MessageOptions<{ INCOMPATIBLE: 'INCOMPATIBLE' }> => {
   const theme = useTheme();
   return {
      INCOMPATIBLE: {
         color: theme.warning,
         backgroundColor: theme.warningLighter,
      },
   };
};

type IncompatibleServiceStatusProps = {
   service: WaitlistReceptionService | null;
   videoConsultationSelected: boolean;
};

export const IncompatibleServiceStatus = (props: IncompatibleServiceStatusProps): ReactElement | null => {
   const shouldDisplayOnSiteWarning =
      props.service?.deliveryMode === 'VIDEO_CONSULTATION' && !props.videoConsultationSelected;
   const shouldDisplayOnlineWarning = props.service?.deliveryMode === 'ON_SITE' && props.videoConsultationSelected;
   const options = useOptions();

   if (!shouldDisplayOnlineWarning && !shouldDisplayOnSiteWarning) {
      return null;
   }

   return (
      <Message
         testId={'incompatibleServiceDeliveryMode'}
         type={'INCOMPATIBLE'}
         options={options}
         displayIndicator
         label={
            shouldDisplayOnSiteWarning
               ? translationKeys.makeSureThatServiceCanBePerformedOnSite
               : translationKeys.makeSureThatServiceCanBePerformedOnline
         }
      />
   );
};
